import { https } from "../http";
import store from "../store";
import {
  setSkypointProspects,
  setSkypointProspectsLoading,
  setSkypointProspectsStatus,
} from "../store/reducers/skypointProspect";
import { showError } from "../utils";
import swal from "sweetalert";

const addSkypointProspect = async (data, callGetProspectWithFiltersCount) => {
  try {
    let response = await https().post("/skypointProspect", data);
    if (response?.status === 200) {
      swal({
        title: response?.data?.message,
        icon: "success",
        dangerMode: false,
      });
      callGetProspectWithFiltersCount?.();
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};


const getAllSkypointProspects = async (
  page = 1,
  activeFilter = undefined,
  filtersCount = [],
  sortBy = "newest",
  search = "",
  showLoading = true
) => {
  try {
    const strUrl = `/skypointProspect/${page}`;
    if (showLoading) store.dispatch(setSkypointProspectsLoading(true));
    let response = await https().post(strUrl, {
      filtersCount,
      activeFilter,
      sortBy,
      search,
    });
    if (response?.status === 200) {
      store.dispatch(setSkypointProspects(response?.data));
    }
  } catch (error) {
    store.dispatch(setSkypointProspectsLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

const updateSkypointProspect = async (
  data,
  callGetProspectWithFiltersCount
) => {
  try {
    let response = await https().put("/skypointProspect", data);
    if (response?.status === 200) {
      swal({
        title: response?.data?.message,
        icon: "success",
        dangerMode: false,
      });
      callGetProspectWithFiltersCount?.();
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};

const deleteSkypointProspect = async (id, callGetProspectWithFiltersCount) => {
  try {
    let response = await https().delete(`/skypointProspect/${id}`);
    if (response?.status === 200) {
      swal({
        title: response?.data?.message || "",
        icon: "success",
        dangerMode: false,
      });
      callGetProspectWithFiltersCount?.();
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
  }
};

// FOR STATUS
const addSkypointProspectStatus = async (data) => {
  try {
    let response = await https().post("/skypointProspect/add-status", data);
    console.log("🚀 ~ addSkypointProspectStatus ~ response:", response)
    if (response?.status === 200) {
      swal({
        title: response?.data?.message,
        icon: "success",
        dangerMode: false,
      });
      // callGetProspectWithFiltersCount?.();
      return response?.data;
    }
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return false;
  }
};
const getAllSkypointProspectsStatus = async (
  showLoading = true
) => {
  try {
    const strUrl = `/skypointProspect//all-status`;
    if (showLoading) store.dispatch(setSkypointProspectsLoading(true));
    let response = await https().get(strUrl);
    console.log("🚀 ~ getAllSkypointProspectsStatus ~ response:", response)
    if (response?.status === 200) {
      store.dispatch(setSkypointProspectsStatus(response?.data));
    }
  } catch (error) {
    store.dispatch(setSkypointProspectsLoading(false));
    showError(error?.response?.data?.message, error?.response?.status);
  }
};
const getExportSkypointProspects = async (activeFilter, sortBy = "newest", search = "") => {
  try {
    const response = await https().post("/skypointProspect/1", {
      filtersCount: [],
      activeFilter,
      sortBy,
      search,
      exportAll: true,
    });
    if (response?.status === 200) {
      return response?.data?.prospects ?? [];
    }
    return [];
  } catch (error) {
    showError(error?.response?.data?.message, error?.response?.status);
    return [];
  }
};

export {
  addSkypointProspect,
  getAllSkypointProspects,
  updateSkypointProspect,
  deleteSkypointProspect,
  addSkypointProspectStatus,
  getAllSkypointProspectsStatus,
  getExportSkypointProspects,
};
